<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'SupportGroupList', to: { name: 'SupportGroupList' } },
        { name: 'Edit', to: { name: 'SupportGroupEdit', params: { type: $route.params.type } } },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯群組 - {{ groupLabel }}</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- block -->
    <div class="block" v-if="pageTitle != null">
      <!-- Title -->
      <div class="form-item pt-5 d-flex">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="pageTitle.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Subtitle -->
      <div class="form-item pt-5 d-flex">
        <div class="w-240px mr-5">
          <h4>副標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="pageTitle.subtitle"
            placeholder="請輸入副標題"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Image -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-3">圖片</h4>
          <div class="h5 ink-02-medium--text">
            顯示於 Download &amp; Support 選單 <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <ImgUploader
            :imageUrl.sync="pageTitle.image"
            dir="SupportGroup"></ImgUploader>
        </div>
      </div>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    ImgUploader,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('pageTitle', ['pageTitle', 'groupTypeOptions']),
    groupLabel() {
      const option = this.groupTypeOptions.find((o) => o.value === this.$route.params.type);
      return option ? option.text : this.$route.params.type;
    },
  },
  created() {
    this.getPageTitle(this.$route.params.type);
  },
  methods: {
    ...mapActions('pageTitle', {
      savePageTitle: 'save',
      getPageTitle: 'findByType',
    }),
    cancelHandler() {
      this.$router.push({ name: 'SupportGroupList' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.pageTitle.type = this.$route.params.type;
        this.savePageTitle(this.pageTitle).then(() => {
          this.$router.push({ name: 'SupportGroupList' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
